import { createFileRoute } from "@tanstack/react-router"
import Units from "@/app/settings/preferences/units/page"

export const Route = createFileRoute("/settings/preferences/units")({
  component: Units,
})
